import React, { useState } from 'react';
import './questionImage.style.scss';
import { __QuestionImageProps } from './questionImage.type';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import UCheckModal from 'utilities/components/modal/modal.index';

const QuestionImage: React.FC<ConnectedProps<typeof connector> & __QuestionImageProps> = (
    props: ConnectedProps<typeof connector> & __QuestionImageProps,
) => {
    const [display, setDisplay] = useState<boolean>(false);
    if (!props.src) return null;
    return (
        <>
            <UCheckModal
                className="slp-question-desc-image-modal"
                onClose={() => setDisplay(false)}
                status={display}
                size="lg"
            >
                <img className="main-image" src={props.src} alt={''} />
            </UCheckModal>
            <img onClick={() => setDisplay(true)} className="slp-question-desc-img" src={props.src} alt={''} />
        </>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(QuestionImage);
